export interface PreonboardingSection {
  heading: string;
  text: string;
}

export interface PreonboardingItem {
  id: string;
  title: string;
  subtitle: string;
  sections: PreonboardingSection[];
}

export const PREONBOARDING_ITEMS: PreonboardingItem[] = [
  {
    id: "okenko-o-seznamu",
    title: "Okénko o Seznamu",
    subtitle: "Zajímavosti o firmě, směr a důležité novinky.",
    sections: [
      {
        heading: "Kdo jsme",
        text: "Seznam je technologická firma, která dlouhodobě staví služby pro miliony lidí v Česku. Důraz klademe na kvalitu produktu, stabilitu a smysluplný dopad na uživatele.",
      },
      {
        heading: "Kam míříme",
        text: "V letošním roce se soustředíme na rozvoj klíčových produktů, automatizaci interních procesů a lepší uživatelský komfort napříč službami.",
      },
      {
        heading: "Co čekat po nástupu",
        text: "První týdny jsou o seznámení s týmem, prostředím a nástroji. Dostaneš jasný onboarding plán, aby ses mohl rychle zorientovat a začít přispívat.",
      },
    ],
  },
  {
    id: "firemni-kultura",
    title: "Firemní kultura",
    subtitle: "Jak fungujeme jako tým a co je pro nás důležité.",
    sections: [
      {
        heading: "Spolupráce",
        text: "Preferujeme otevřenou komunikaci, sdílení kontextu a férovou zpětnou vazbu. Cílem je, aby se rozhodnutí dělala rychle, ale srozumitelně.",
      },
      {
        heading: "Odpovědnost",
        text: "Každý má prostor přicházet s nápady a posouvat věci dopředu. Spolu s tím jde odpovědnost za kvalitu výstupu i za zkušenost kolegů a uživatelů.",
      },
      {
        heading: "Pracovní rytmus",
        text: "Podporujeme vyvážený režim práce, rozumné plánování a průběžné zlepšování. Když něco nefunguje, řešíme to hned a společně.",
      },
    ],
  },
  {
    id: "tvuj-tym-kontakty",
    title: "Tvůj tým & kontakty",
    subtitle: "Přehled týmu a důležitých kontaktů pro nástup.",
    sections: [],
  },
];
